import { Component,inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, RouterOutlet } from "@angular/router";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { LoaderService } from 'src/app/core/Loader.services';
import { LoaderComponent } from 'src/app/core/loader.component';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';


@Component({
  selector: "app-root",
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    LoaderComponent,
  ],
  template: `
    <!-- <mat-toolbar color="primary">
      <span>CP Central 2.0</span>
      <span class="spacer"></span>
      <button mat-button routerLink="/">Home</button>
      <button mat-icon-button aria-label="Logout" (click)="logout()"><mat-icon>logout</mat-icon></button>
    </mat-toolbar> -->
    <app-loader></app-loader>
    <router-outlet></router-outlet>
   
    
  `,
  styles: [
    `
      .spacer {
        flex: 1 1 auto;
      }
    `,
  ],
})
export class AppComponent {
  private router = inject(Router);
  private loader = inject(LoaderService);
  
 constructor() {
  // Optional: show loader during route transitions
  // this.router.events.subscribe(event => {
  //   if (event instanceof NavigationStart) this.loader.show();
    
  //        if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
  //     this.loader.hide();
  //   }
  // });
  
}
logout() {}
}
